import { render } from "./RecentRegisteredCustomers.vue?vue&type=template&id=c8644bb4"
import script from "./RecentRegisteredCustomers.vue?vue&type=script&lang=js"
export * from "./RecentRegisteredCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__